import { baseApi } from "../base.api";

const BASE_ENDPOINT = "/api/chatbot/query";

export const chatbotApi = baseApi
  .enhanceEndpoints({
    addTagTypes: ["Chatbot"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      talkChatbot: builder.query({
        query: (params) => ({
          url: BASE_ENDPOINT,
          method: "GET",
          params,
        }),
      }),
    }),
  });

export const { useLazyTalkChatbotQuery, useTalkChatbotQuery } = chatbotApi;
